module.exports = __webpack_public_path__ + "img/fzlc.77deca64.png";